import { useCurrentUser } from "web/hooks/data"

import ViewerLink from "./ViewerLink"

export default function PortfolioViewer({
  value,
  showLinkIcon,
  truncateValue,
}) {
  const currentUser = useCurrentUser()
  if (!currentUser || currentUser.is_guest) return <span>{value.label}</span>

  return (
    <ViewerLink
      href={`/portfolios/all/view/${value.value}`}
      label={value.label}
      showLinkIcon={showLinkIcon}
      truncateValue={truncateValue}
    />
  )
}

PortfolioViewer.isViewerFor = (x) => x.kind === "Portfolio"
